import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { AiFilterChip } from '~/components/AiSearchChips/AiFilterChip/AiFilterChip';
import { checkboxesToSet, rebuildDecimalField, rebuildSetField, setToCheckboxes } from './serviceConditions';
import { decimalEditableValue, decimalFromInput, decimalIsEditable, decimalValueLabel, parseDecimal } from './serviceDecimal';
export const billingDimensionItems = (values, label)=>values.map((value)=>({
            value,
            label: label(value)
        }));
export const billingDimensionChip = (param)=>{
    let { field, testId, fieldLabel, items, selected, biPrefix, tone, onApply, onRemove } = param;
    return /*#__PURE__*/ _jsx(AiFilterChip, {
        mode: "checkboxes",
        testId: testId,
        fieldLabel: fieldLabel,
        items: items,
        selected: selected,
        operator: "include",
        tone: tone,
        onApply: (param)=>{
            let { selected: next } = param;
            return onApply(next);
        },
        onRemove: onRemove,
        biPrefix: biPrefix
    }, field);
};
export const serviceSetChipProps = (param)=>{
    let { field, fieldLabel, items, biPrefix, predicate, tone, testId, apply } = param;
    const { selected, operator } = setToCheckboxes(predicate[field]);
    return {
        mode: 'checkboxes',
        testId,
        fieldLabel,
        items,
        selected,
        operator,
        tone,
        onApply: (next)=>apply(rebuildSetField(predicate, field, checkboxesToSet(next))),
        onRemove: ()=>apply(rebuildSetField(predicate, field, undefined)),
        biPrefix
    };
};
export const serviceDecimalChipProps = (param)=>{
    let { field, fieldLabel, biPrefix, removedValue, range, predicate, tone, testId, texts, apply } = param;
    return {
        mode: 'numberRange',
        testId,
        fieldLabel,
        value: decimalEditableValue(range),
        valueLabel: decimalValueLabel(range),
        tone,
        editable: decimalIsEditable(range),
        validate: (input)=>parseDecimal(input),
        onApply: (input)=>apply(rebuildDecimalField(predicate, field, decimalFromInput(input, range.neq != null))),
        onRemove: ()=>apply(rebuildDecimalField(predicate, field, removedValue)),
        biPrefix,
        texts
    };
};
export const serviceChipPropsFor = (param)=>{
    let { predicate, tone, chipTestId, apply, numberRangeTexts } = param;
    return {
        set: (param)=>{
            let { field, fieldLabel, items, biPrefix } = param;
            return serviceSetChipProps({
                field,
                fieldLabel,
                items,
                biPrefix,
                predicate,
                tone,
                testId: chipTestId(field),
                apply
            });
        },
        decimal: (args)=>serviceDecimalChipProps(_object_spread_props(_object_spread({}, args), {
                predicate,
                tone,
                testId: chipTestId(args.field),
                texts: numberRangeTexts,
                apply
            }))
    };
};
